// extracted by mini-css-extract-plugin
export default {"item":"styles_item__bJE+V","checkbox":"styles_checkbox__JpaoD"};